import { SentimentIconZ } from '@/constants/icons';
import {
  Activity,
  ArrowDownCircle,
  ArrowLeftRight,
  Ban,
  CaseLower,
  CircleArrowRight,
  Clock,
  Coins,
  CopyIcon,
  Divide,
  DollarSign,
  Hash,
  HeartPulse,
  Languages,
  List,
  LocateFixed,
  MessageCircle,
  MessageCircleHeart,
  MessageCircleWarning,
  MessageSquare,
  MessageSquareReply,
  MessagesSquare,
  Star,
  Tag,
  ThumbsDown,
  ThumbsUp,
  Timer,
  TrendingUp,
  TriangleAlert,
  User2,
} from 'lucide-react';
import type { ReactNode } from 'react';

const iconClass = 'inline size-3 shrink-0';

const datatableColumnIconMap: { [key: string]: ReactNode } = {
  user2: <User2 className={iconClass} />,
  activity: <Activity className={iconClass} />,
  messagessquare: <MessagesSquare className={iconClass} />,
  locatefixed: <LocateFixed className={iconClass} />,
  sentimenticonz: <SentimentIconZ className={iconClass} />,
  messagecircleheart: <MessageCircleHeart className={iconClass} />,
  messagecirclewarning: <MessageCircleWarning className={iconClass} />,
  arrowdowncircle: <ArrowDownCircle className={iconClass} />,
  clock: <Clock className={iconClass} />,
  thumbsup: <ThumbsUp className={iconClass} />,
  thumbsdown: <ThumbsDown className={iconClass} />,
  messagesquare: <MessageSquare className={iconClass} />,
  messagesquarereply: <MessageSquareReply className={iconClass} />,
  divide: <Divide className={iconClass} />,
  tag: <Tag className={iconClass} />,
  topic: <List className={iconClass} />,
  conversation: <MessageCircle className={iconClass} />,
  turns: <ArrowLeftRight className={iconClass} />,
  default: <Tag className={iconClass} />,
  cost: <DollarSign className={iconClass} />,
  latency: <Timer className={iconClass} />,
  text_language: <Languages className={iconClass} />,
  verbosity: <CaseLower className={iconClass} />,
  feedback_action_text: <MessageSquare className={iconClass} />,
  feedback_actions: <Ban className={iconClass} />,
  feedback_action_rating: <Star className={iconClass} />,
  sentiment: <SentimentIconZ className={iconClass} />,
  emotions: <HeartPulse className={iconClass} />,
  pii_removed: <Tag className={iconClass} />,
  paste_output: <CopyIcon className={iconClass} />,
  circlearrowright: <CircleArrowRight className={iconClass} />,
  penetration: <TrendingUp className={iconClass} />,
  id: <Hash className={iconClass} />,
  tokens: <Coins className={iconClass} />,
  trianglealert: <TriangleAlert className={iconClass} />,
  heartpulse: <HeartPulse className={iconClass} />,
};

export function getDatatableColumnIconNode(iconKey: string): ReactNode {
  return datatableColumnIconMap[iconKey] ?? datatableColumnIconMap.default;
}
